import Arrears from './arrears';

export default Arrears;
